import { Module } from "../lib/modules";
import { moduleRegistry } from "../lib/registry";
import { StateManager } from "../lib/stateManager";

type AuthorState = {
  offset: number;
}

export const Author: Module<AuthorState> = () => {
  const state = new StateManager<AuthorState>({
    offset: 9,
  })

  const init = () => {
    const loadMoreBtn = document.querySelector(".js-load-more-btn");
    const articlesGrid = document.querySelector(".js-articles-grid");
    const authorID = (document.querySelector(".author-page") as HTMLDivElement).dataset["authorid"];
    let limit = 9;

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", async () => {
        let offset = state.get("offset");

        try {
          // const authorId = window.location.pathname.split("/").pop();
          const response = await fetch(`/api/more_latest_articles?offset=${offset}&limit=${limit}&author=${authorID}`);
          if (!response.ok) {
            throw new Error("Failed to load more articles");
          }
          const data = await response.text();

          // Run skeleton module on new images
          let skeleton = (_container: Element) => { };
          const skeletonModule = moduleRegistry.get("imageSkeleton");
          if (skeletonModule) {
            skeleton = skeletonModule.instance.state.get("skeleton");
          }

          const parser = new DOMParser();
          const doc = parser.parseFromString(data, "text/html");
          const newArticles = doc.querySelectorAll(".home__article-card");
          for (const article of newArticles) {
            const articleCard = article as HTMLDivElement;
            const articleCardAnchor = articleCard.querySelector("a") as HTMLAnchorElement;
            if (!articlesGrid) continue;
            articlesGrid.appendChild(articleCard);

            skeleton(articleCardAnchor);
          }

          // Update offset
          const newOffset = state.get("offset") + newArticles.length;
          if (newArticles.length < 9) {
            loadMoreBtn.remove();
          }

          state.set("offset", newOffset);

        } catch (error) {
          console.error(error);
        }
      });
    }
  }

  const destroy = () => { }

  return {
    init,
    destroy,
    state: state as StateManager<AuthorState>,
    name: "author",
    pages: ["/authors/*"],
  }
}
